{
  "browserNotSupported": {
    "title": "Error loading the module",
    "text": "Please switch to an up-to-date browser to use the accessories module."
  },
  "main": {
    "more": "More Accessories",
    "findMore": "You can find accessories for retrofitting/converting and upgrading your vehicle here in our extensive offer. The accessories you have selected will be sent to your {{brand}} partner together with the vehicle request.",
    "topOffers": "TOP Offers",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Products",
    "noArticleFound": "0 Products",
    "oemHint": "Select matching accessories for your {{brand}} now!",
    "noBrand": "Select matching accessories for your vehicle now!",
    "outOfOrder": "Unfortunately there are no products available at the moment.<0/>We are currently updating our catalogue.<0/>Please visit us again at a later date.",
    "nextSlide": "Next",
    "prevSlide": "Previous"
  },
  "cart": {
    "add": "Product added to vehicle",
    "fullPrice": "Price vehicle and accessories",
    "priceWithoutCar": "Price accessories"
  },
  "navigation": {
    "zoom": "Zoom",
    "toggleSearch": "Toggle search",
    "cart": "Cart",
    "cartDelete": "Remove item from cart",
    "vehicle": "Selected vehicle",
    "maxBookmarksReached": "Maximum of 15 products reached",
    "filter": {
      "toggleFilter": "Toggle filter",
      "topProducts": "TOP Offers",
      "reset": "Reset filter",
      "ready": "Done",
      "show": "Show results"
    },
    "searching": {
      "submit": "Submit",
      "close": "Close",
      "placeholder": "Find matching accessories ...",
      "suggestions": "Search suggestions",
      "categories": "Categories",
      "products": "Products",
      "productCount": "{{count}} product",
      "productCount_other": "{{count}} products",
      "showAll": "Show {{count}} result",
      "showAll_other": "Show all {{count}} results",
      "expand": "Expanded Search",
      "show": "Product to show",
      "found": {
        "withCategory": "Search results for \"{{fuzzy}}\" in category \"{{category}}\"",
        "withOutCategory": "Search results for \"{{fuzzy}}\" from all categories"
      }
    },
    "share": "Share",
    "back": "Back",
    "details": "Details",
    "add": "Add",
    "remove": "Remove",
    "close": "Close",
    "filtern": "Filter",
    "closeFilter": "Close filter"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Jump to image {{number}}"
    },
    "articleNumber": "Article number",
    "relatedArticle": "You might also be interested in these articles:",
    "brand": "Brand",
    "priceBox": {
      "withVatAndMounting": "incl. VAT & fitting",
      "withVat": "incl. VAT",
      "recommendedRetailPrice": "RRP",
      "historicMinimalPurchasePrice": "Lowest price last 30 days",
      "priceDetails": "Price details",
      "priceDetailsHeadline": "Price details for this item",
      "priceToday": "Price for this item today",
      "priceDetails30Days": "Lowest price in the 30 days prior to the price change",
      "close": "Close",
      "addItem": "Add article",
      "removeItem": "Remove article"
    },
    "infoBox": {
      "description": "Description",
      "vehicles": "Suitable for the following models",
      "empty": "There are no special vehicle assignments for this product.",
      "contacts": "Manufacturer"
    },
    "contacts": {
      "manufacturer-contact": "Manufacturer Contact Information",
      "responsible-contact": "Responsible Person within EU",
      "trademark": "Brand"
    }
  },
  "productList": {
    "oemHint": "Original accessories for your {{brand}}"
  }
}
